import React, { useState } from "react";
import { Redirect } from "react-router-dom";

export default function AuthRedirect() {
  const [pathname] = useState("/");
  return <Redirect to={{ pathname }} />;
}
